import React, { Component } from "react";
import { InputField } from "../../../../common/custom-form/input-filter-component";
import { SelectField } from "../../../../common/custom-form/select-filter.component";

export class ManageUserInfo extends Component {
    constructor(props){
        super(props);
        this.state={
            inputValue: "",
            filterSelected: "", 
            showTable: false,
            showRate: false,
            detailsDropdown:[
                {
                    "title":"Plan Features",
                    "subTitle":"Feature Name",
                    "dataTable":[
                        {              
                            HeaderItem:[
                                {
                                    name:"Contract Name"
                                },
                                {
                                    name:"Vendor"
                                }, {
                                    name:"Status"
                                },{
                                    showTable:false
                                }
                            ],
                            dataItem:[{            
                                columnItem1:"3G Hutchison (GB) Contract",
                                columnItem2: "3G Hutchison (GB)",
                                columnItem3: "Expired"                       
                            }, {            
                                columnItem1:"3G Hutchison (GB) Contract",
                                columnItem2: "3G Hutchison (GB)",
                                columnItem3: "Expired"
                            },{            
                                columnItem1:"3G Hutchison (GB) Contract",
                                columnItem2: "3G Hutchison (GB)",
                                columnItem3: "Expired"
                            }        
                            ]
            
                        }
                    ]
                },{
                    "title":"Plan Rates",
                    "subTitle":"Rate Name",
                    "dataTable":[
                        {              
                            HeaderItem:[
                                {
                                    name:"Contract Name"
                                },
                                {
                                    name:"Vendor"
                                }, {
                                    name:"Status"
                                }, {
                                    showTable:false
                                }
                            ],
                            dataItem:[{            
                                columnItem1:"3G Hutchison (GB) Contract",
                                columnItem2: "3G Hutchison (GB)",
                                columnItem3: "Expired"                       
                            }, {            
                                columnItem1:"3G Hutchison (GB) Contract",
                                columnItem2: "3G Hutchison (GB)",
                                columnItem3: "Expired"
                            },{            
                                columnItem1:"3G Hutchison (GB) Contract",
                                columnItem2: "3G Hutchison (GB)",
                                columnItem3: "Expired"
                            }        
                            ]
            
                        }
                    ]
                }
            ],
            selectFilter:[
                {
                    "FilterId":5,
                    "FilterName":"Account Number",
                    "FilterType":"Textbox",
                    "Page":"CircuitInventoryReport",
                    "State":true,"Createdby":null,
                    "DateCreated":"0001-01-01T00:00:00",
                    "Modifiedby":null,
                    "DateModified":null,
                    "DropDownFilterOpts":null
                },
                {
                    "FilterId":4,
                    "FilterName":"Circuit ID",
                    "FilterType":"Textbox","Page":
                    "CircuitInventoryReport",
                    "State":true,"Createdby":null,
                    "DateCreated":"0001-01-01T00:00:00",
                    "Modifiedby":null,
                    "DateModified":null,
                    "DropDownFilterOpts":null
                },
                {
                    "FilterId":7,
                    "FilterName":"Circuit Status",
                    "FilterType":"Textbox",
                    "Page":"CircuitInventoryReport",
                    "State":true,"Createdby":null,
                    "DateCreated":"0001-01-01T00:00:00",
                    "Modifiedby":null,
                    "DateModified":null,
                    "DropDownFilterOpts":null
                }
               ],
               dataTable:[
                {              
                    HeaderItem:[
                        {
                            name:"Contract Name"
                        },
                        {
                            name:"Vendor"
                        }, {
                            name:"Status"
                        }
                    ],
                    dataItem:[{            
                        columnItem1:"3G Hutchison (GB) Contract",
                        columnItem2: "3G Hutchison (GB)",
                        columnItem3: "Expired"                       
                    }, {            
                        columnItem1:"3G Hutchison (GB) Contract",
                        columnItem2: "3G Hutchison (GB)",
                        columnItem3: "Expired"
                    },{            
                        columnItem1:"3G Hutchison (GB) Contract",
                        columnItem2: "3G Hutchison (GB)",
                        columnItem3: "Expired"
                    }        
                    ]
    
                }
            ],
        }
    }

  
    render() {
        return(
            <>
                <div className="manage-order-container">
                        <div className="manage-order-detail">                            
                            <InputField label="HR/SAP ID" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                            <InputField label="Line Manager HR/SAP ID" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                            <InputField label="Position" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                            <InputField label="End User" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                            <InputField label="Line Manager" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                            <InputField label="Status" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                            <InputField label="Email Address" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                            <InputField label="Line Manager Email" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                            <InputField label="Date Left" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                            <InputField label="Primary Subscription No." testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                            <InputField label="Second Line Manager Email" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                            <InputField label="Delegate Approval" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                        </div>
                        <h1>Location Details</h1>
                        <div className="manage-order-detail grid-2-1fr-column">                            
                            <InputField label="Region" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                            <InputField label="Site" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                            <InputField label="Country" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                            <InputField label="Site Code" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                            <InputField label="City" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                            <InputField label="Cost Code" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                            <InputField label="Devision" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />                           
                        </div>
                    </div>                  
            </>
        )
    }
}